import React from 'react';
import { PropsOf } from '../../../../../ui';
import { StyledCreditCardLogo } from '@move-frontend/form';
import { AmericanExpressLogo } from './AmericanExpressLogo';
import { MastercardLogo } from './MastercardLogo';
import { VisaLogo } from './VisaLogo';
import { DiscoverLogo } from './DiscoverLogo';
import { CreditCardType } from '../../../domain/models';
import { handleInvalidValue } from '../../../../shared/error/handleInvalidValue';

interface ICreditCardLogoProps extends PropsOf<typeof StyledCreditCardLogo> {
	type: CreditCardType;
}

export const CreditCardLogo = ({ type, ...rest }: ICreditCardLogoProps) => {
	switch (type) {
		case CreditCardType.AmericanExpress:
			return <AmericanExpressLogo {...rest} />;

		case CreditCardType.Mastercard:
			return <MastercardLogo {...rest} />;

		case CreditCardType.Visa:
			return <VisaLogo {...rest} />;

		case CreditCardType.Discover:
			return <DiscoverLogo {...rest} />;

		default:
			handleInvalidValue(type);
			return type;
	}
};
